// Günlük bütçe hesap yardımcıları — bileşen dışı saf fonksiyonlar
import { fmtTL } from "../../lib/format";

export const AYLAR = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
export const fmtIn = (n) => (n ? fmtTL(n).replace(/\s*TL$/, "") : "");
export const num = (v) => (v ? fmtTL(v) : "-");
export const diff = (plan, actual) => (plan || actual ? fmtTL(plan - actual) : "-");
// gelir farkı: gerçekleşen − plan (1.000 plan, 900 gerçekleşen → −100)
export const diffInc = (plan, actual) => (plan || actual ? fmtTL(actual - plan) : "-");

export const monthDays = (month) => {
  const [y, m] = month.split("-").map(Number);
  const dayCount = new Date(y, m, 0).getDate();
  return { y, m, dayCount, dayList: Array.from({ length: dayCount }, (_, i) => String(i + 1).padStart(2, "0")) };
};

// Bugünün ay içindeki günü: geçmiş ay → dayCount+1 (hepsi geçti), gelecek ay → 0
export const todayDayOf = (month, todayIso, dayCount) => {
  const curYM = todayIso.slice(0, 7);
  if (month === curYM) return Number(todayIso.slice(8, 10));
  return month < curYM ? dayCount + 1 : 0;
};

// Plan detayı, gerçekleşmeler ve gecikme hesapları (dayMap / plan_details üzerinden)
export function makeBudgetCalc({ dayMap, dayList, details, leafs, todayDay }) {
  const pd = (id) => { const x = details[id]; return x ? { income: Number(x.income) || 0, expense: Number(x.expense) || 0, day: x.day == null ? null : Number(x.day) } : { income: 0, expense: 0, day: null }; };
  const realizedDay = (id, key) => dayList.find((d) => (dayMap[d]?.[id]?.[key] || 0) > 0) || null;
  const realizations = (id, key) => dayList.filter((d) => (dayMap[d]?.[id]?.[key] || 0) > 0).map((d) => ({ day: Number(d), amount: dayMap[d][id][key] || 0 }));
  const monthTotal = (id, key) => realizations(id, key).reduce((s, r) => s + r.amount, 0);
  const isLate = (id, key) => { const p = pd(id); return p[key] > 0 && p.day && p.day < todayDay && !realizedDay(id, key); };
  const lateLeaves = (d) => leafs.filter((l) => pd(l.id).day === Number(d) && (isLate(l.id, "income") || isLate(l.id, "expense")));
  return { pd, realizations, monthTotal, lateLeaves };
}

// Güne kadar kümülatif gerçekleşen (yalnız planlı kalemler) — plan aşımı rozeti/bandı için
export function cumulativeByDay(dayMap, dayList, plannedIds) {
  const m = {};
  let inc = 0, exp = 0;
  for (const d of dayList) {
    const dayItems = dayMap[d];
    if (dayItems) Object.entries(dayItems).forEach(([iid, v]) => {
      if (!plannedIds.has(iid)) return;
      inc += v.income || 0; exp += v.expense || 0;
    });
    m[d] = { inc, exp };
  }
  return m;
}
